import handlebars from 'handlebars';
import { translations } from '../composables/use-update-translations';
import { useHLocale } from '../composables/use-translate';

function processHandleBars(source: string, data?: Object): string {
  if (source && source !== '') {
    source = source.replace(/\\/g, '_@__');
  }

  if (data) {
    source = source.replace(/\{([^{}]+)\}/g, (match, key) => (Object.prototype.hasOwnProperty.call(data, key) ? `{{${key}}}` : match));
  }

  const tpl = handlebars.compile(source);
  let value = tpl(data);
  if (value && value !== '') {
    value = value.replace(/_@__/g, '\\');
  }
  try {
    return JSON.parse(value);
  } catch (_e) {
    return value;
  }
}

function translate(key: string, data?: Object, fallbackLocale?: string) {
  // Get Locale
  const { locale } = useHLocale();

  const translation = translations[locale.value]?.[key] ?? translations[fallbackLocale ?? '']?.[key] ?? key;

  return processHandleBars(translation, data);
}

export { translate };
